import type { Currency } from "@porsche-customer/slfinrtl-context-types"

export const PERCENTAGE_DROP_BY_YEAR = 5
export const MAX_NUMBER_OF_YEARS_TO_DROP = 15

export const getCurrencyLimit = (currency: Currency): number | undefined => currencyLimit[currency]

const currencyLimit: Record<Currency, number> = {
	AED: 156375,
	AMD: 17391304,
	ANG: 76843,
	AUD: 62939,
	BAM: 78669,
	BGN: 78301,
	BHD: 16044,
	BND: 57516,
	BOB: 294535,
	BRL: 222965,
	CAD: 40000,
	CHF: 40000,
	CLP: 35182898,
	CNY: 150000,
	COP: 202039827,
	CZK: 937481,
	DKK: 298994,
	EGP: 1304159,
	EUR: 40000,
	GBP: 35000,
	HKD: 334172,
	HUF: 15045116,
	IDR: 64936435346,
	ILS: 154363,
	INR: 3512555,
	ISK: 5750000,
	JMD: 6556478,
	JOD: 30197,
	JPY: 5700000,
	KHR: 184120000,
	KRW: 55605639,
	KWD: 13062,
	KZT: 18992034,
	LKR: 15446086,
	MAD: 443672,
	MKD: 2478559,
	MNT: 145110623,
	MUR: 1973600,
	MXN: 777832,
	MYR: 190494,
	NOK: 440000,
	NZD: 68106,
	OMR: 16379,
	PHP: 2340463,
	PLN: 187796,
	QAR: 155102,
	SAR: 159926,
	SEK: 440774,
	SGD: 57139,
	THB: 1480402,
	TND: 134876,
	TRY: 804960,
	TTD: 289801,
	TWD: 1300000,
	UAH: 1577976,
	USD: 40000,
	UZS: 558755985,
	VND: 1011339810,
	XPF: 4800163,
	ZAR: 772819,
}
